import { isEmpty } from 'lodash-es';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';

export const useGetWSMActiveLocationIds = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { getCustomizationFlagLocationMap } = useAppFlagStore();

  const wsmActiveLocationIds = Object.entries(
    getCustomizationFlagLocationMap({ locationIds: selectedLocationIds, flagName: 'weaveschedulemanagement' })
  )
    .filter(([, flag]) => flag?.state === 'ACTIVE')
    .map(([locationId]) => locationId);

  return { wsmActiveLocationIds };
};

export const useGetSchedulerV3FeatureFlagDetails = () => {
  const { featureFlags } = useAppFlagStore();
  const isFeatureFlagsLoaded = !isEmpty(featureFlags);

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  const hasSchedulerV3UI = getFeatureFlagValue('scheduler-v3-ui', 'ALL');

  const isLoading = isLoadingIntegrationDetails || !isFeatureFlagsLoaded;

  const isV3Enabled = hasSchedulerV3UI || !isIntegratedOffice;

  return {
    isScheduleV3FlagEnabled: isLoading ? false : isV3Enabled,
    isSchedulerV2FlagEnabled: isLoading ? false : !isV3Enabled,
    isLoading: isLoadingIntegrationDetails || !isFeatureFlagsLoaded,
  };
};
